import { createSlice } from '@reduxjs/toolkit'

export const deviceSlice = createSlice({
  name: 'device',
  initialState: {
    deviceDetails: {
      id: '',
      uuid: null,
      latitude: '', 
      longitude: '',
      locale: '',
      manufacturer: '',
      model: '',
      os_name:'',
      os_version: '',
      isMobile: null,
      isIphone: null
    }
  },
  reducers: {
    updateDeviceDetails: (state, action) => {
      state.deviceDetails = action.payload;
    }
  }
})

export const { updateDeviceDetails } = deviceSlice.actions

export default deviceSlice.reducer